import React, { useState } from 'react'
import NavigationBar from '../../components/Navigationbar/Navigationbar'
import { Box, Link } from '@mui/joy'

function Organisation() {
    const [wit, setWit] = useState("90.5%");
    return (
        <>
            <Box
                sx={{
                    width: wit,
                    position: "fixed",
                    top: 0,
                    right: 0,
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    bgcolor: "background.body",
                    borderLeft: "1px solid",
                    borderColor: "divider",
                    overflowY: "auto",
                }}
            >
            <Link sx={{mt: 2}} href={window.location.origin + "/organisation_view/vermittlernummern"}>Vermitterlte Gesellschaften</Link>
            <Link sx={{mt: 2}} href={window.location.origin + "/organisation_view/verwaltungsprogramm"}>Bestandführeung und Verwaltungsprogramm</Link>
            <Link sx={{mt: 2}} href={window.location.origin + "/organisation_view/husk"}>Vergleichsprogramm HUSK</Link>
            <Link sx={{mt: 2}} href={window.location.origin + "/organisation_view/invest"}>Vergleichsprogramm Invest</Link>
            <Link sx={{mt: 2}} href={window.location.origin + "/organisation_view/KVLV"}>Vergleichsprogramm KV + LV</Link>
            <Link sx={{mt: 2}} href={window.location.origin + "/organisation_view/weiteremitgliedschaften"}>Weitere Mitgliedschaften</Link>


            </Box>
            <NavigationBar state={"profile"} back={true} />
        </>
    )
}

export default Organisation
